/**
 * The preview strip on a dashboard card. Decorative, not a render: a live
 * preview would need a minted single-use token and a sandboxed frame per
 * card, and the list record carries no widget data to draw from.
 *
 * Everything is derived from `seed` (the dashboard id), so a card looks the
 * same on every visit and different from its neighbours.
 */

const BARS = 16;
const STATS = ['28.0°', '47%', '-59', '2.81V', '24.1°', '61%', '3.02V', '1013 hPa'];

// FNV-1a: a stable 32-bit hash of the seed.
const hash = (s) => {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
};

// mulberry32: a small deterministic PRNG over that hash.
const rng = (seed) => {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

export function CardPreview({ seed = '' }) {
  const next = rng(hash(String(seed)));
  const bars = Array.from({ length: BARS }, () => 20 + Math.round(next() * 80));
  const first = Math.floor(next() * STATS.length);
  const second = (first + 1 + Math.floor(next() * (STATS.length - 1))) % STATS.length;

  return (
    <div aria-hidden="true" className="flex gap-3 bg-[#efefeb] p-5 dark:bg-gray-800">
      <div className="flex h-36 flex-1 items-end gap-1 rounded-lg border border-gray-200 bg-white p-3 dark:border-gray-800 dark:bg-gray-900">
        {bars.map((h, i) => (
          <div key={i} className="flex-1 rounded-sm bg-blue-400/70" style={{ height: `${h}%` }} />
        ))}
      </div>
      <div className="flex w-2/5 flex-col gap-3">
        {[STATS[first], STATS[second]].map((v, i) => (
          <div
            key={i}
            className="flex flex-1 items-center rounded-lg border border-gray-200 bg-white px-3 font-mono text-lg text-gray-900 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-50"
          >
            {v}
          </div>
        ))}
      </div>
    </div>
  );
}
